/**
 * @legacy
 * @prev administration/templates/administration/permissions_create_update.html
 */

import "jquery-ui";

$.fn.toggleAccountPermissions = function () {
  if ($("#id_customer_full_accounts").is(":checked")) {
    /* Hide accounts permissions */
    $("#form_permission_account").hide();
  } else {
    $("#form_permission_account").show();
    $().displayAccountPermissions();
  }
};
$.fn.displayAccountPermissions = function () {
  /* Hide account permissions */
  $("div[id$='_account_permissions']").hide();
  /* Show account permissions we want to see */
  var account_id = $("#id_account option:selected").val();
  $("#" + account_id + "_account_permissions").show("highlight");
};
$.fn.toggleServerPermissions = function () {
  if ($("#id_customer_full_servers").is(":checked")) {
    /* Hide server permissions */
    $("#form_permission_server").hide();
  } else {
    $("#form_permission_server").show();
    $().displayServerPermissions();
  }
};
$.fn.displayServerPermissions = function () {
  /* Hide server permissions */
  $("div[id$='_server_permissions']").hide();
  /* Show server permissions we want to see */
  var server_id = $("#id_server option:selected").val();
  $("#" + server_id + "_server_permissions").show("highlight");
};
$(document).ready(function () {
  $("#nav-permission").addClass("active");
  $().toggleAccountPermissions();
  $().toggleServerPermissions();
  $("#id_customer_full_accounts").on("change", function () {
    $().toggleAccountPermissions();
  });
  $("#id_account").on("change", function () {
    $().displayAccountPermissions();
  });
  $("#id_customer_full_servers").on("change", function () {
    $().toggleServerPermissions();
  });
  $("#id_server").on("change", function () {
    $().displayServerPermissions();
  });
  $("#generic_form").parent().show("fast");

  /* Allows to check or uncheck all checkboxes for a given permissions subform (account, server) */
  const checkAllLinks = document.querySelectorAll('a[id$="check_all"]');
  checkAllLinks.forEach((checkAllLink) => {
    const elementId = checkAllLink.id.split("_")[0];
    const elementCheckBoxes = document.querySelectorAll(
      'input[id^="id_' + elementId + '_"]',
    );
    checkAllLink.addEventListener("click", function (event) {
      let action = true ? checkAllLink.dataset.action === "check" : false;
      elementCheckBoxes.forEach((element) => (element.checked = action));
    });
  });
});
